import React, { useEffect, useRef } from 'react';
import { Form, Modal, Spin } from 'antd';
import { useModal, modalType } from '../../modalProvider';
import usePermits from '../../api/usePermits';
import BodyFormPermit from '../BodyFormPermit/BodyFormPermit';
import useCreatePermit from '../../api/mutation/useCreatePermit';
import { links } from '../../constants/links';
import { useRouteMatch } from 'react-router-dom';
import FooterModal from '../../../../../components/FooterModal/FooterModal';
import useChangePermit from '../../api/mutation/useChangePermit';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { resetPermitFilter } from '../../store/action';
import useCheckCanAddPermitQuery from '../../../../../queries/useCheckCanAddPermitQuery';
import { permitConstants } from '../../../../../constants/permit.constants';

const confirm = Modal.confirm;

const ModalPermitNode = ({ form }) => {
  const { resetFields, validateFields, getFieldValue } = form;

  const dispatch = useDispatch();

  const clientIdValue = getFieldValue('clientId');
  const transportPermitTypeIdValue = getFieldValue('transportPermitTypeId');
  const startDateValue = getFieldValue('startDate');

  const { isOpen, props, close } = useModal(modalType.PERMIT_FORM);

  const { id, onSuccess } = props || {};

  const isEdit = !!id;

  const match = useRouteMatch(`${links.rootWithCompany}/:companyId/:page`);

  const { companyId } = match?.params || {};

  const { data: permit = {}, isFetching } = usePermits(
    { transportPermitId: id },
    { enabled: !!id, select: (data) => data?.[0] || {} }
  );
  const { data: canAddPermit, isFetching: isLoadingCheck } =
    useCheckCanAddPermitQuery(
      {
        transportPermitTypeId: transportPermitTypeIdValue,
        clientId: clientIdValue,
        companyId,
      },
      {
        enabled: Boolean(
          transportPermitTypeIdValue &&
            transportPermitTypeIdValue !== 3 &&
            clientIdValue &&
            companyId &&
            isOpen
        ),
        staleTime: 0,
        select: (data) => data?.success || undefined,
      }
    );

  const { mutateAsync: createPermit, isLoading: isLoadingCreatePermit } =
    useCreatePermit(onSuccess);
  const { mutateAsync: changePermit, isLoading: isLoadingChangePermit } =
    useChangePermit(onSuccess);

  const editingAcccess =
    transportPermitTypeIdValue === permitConstants.ONE_TIME_PASS
      ? true
      : canAddPermit;

  const handleResetFilter = () => {
    dispatch(resetPermitFilter());
  };

  const handleCancel = () => {
    resetFields();

    useRef.current = false;
    close();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const value = moment(startDateValue).startOf('minute');
    const now = moment().startOf('minute');

    const timeCheck = value.isBefore(now);

    if (timeCheck) {
      form.setFieldsValue({
        startDate: moment(),
        expireDate: moment().add(4, 'hours'),
      });
    }

    validateFields(async (err, values) => {
      if (!err) {
        const { houseId, streetId, expireDate, startDate, ...restValues } =
          values || {};

        if (isEdit) {
          await changePermit({
            id,
            value: {
              permitStatusId: restValues?.permitStatusId,
              startDate: moment(startDate).toISOString(),
              ...(restValues?.permitStatusId === 5 &&
              restValues?.permitStatusId !== permit?.permitStatus?.id
                ? { cancellationDate: moment().toISOString() }
                : {}),
              ...(permit?.permitType?.id === permitConstants.TEMPORARY_PASS
                ? {
                    expireDate: moment
                      .utc(
                        moment(expireDate).format('YYYY-MM-DD') +
                          'T23:59:59.999Z'
                      )
                      .toISOString(),
                  }
                : {}),
              availableForClient: true,
              ...(restValues?.comment ? { comment: restValues?.comment } : {}),
            },
          });
        } else {
          await createPermit({
            ...restValues,
            startDate: moment(startDate).toISOString(),
            ...(transportPermitTypeIdValue === permitConstants.TEMPORARY_PASS
              ? {
                  expireDate: moment
                    .utc(
                      moment(expireDate).format('YYYY-MM-DD') + 'T23:59:59.999Z'
                    )
                    .toISOString(),
                }
              : {}),
          });

          handleResetFilter();
        }

        handleCancel();
      }
    });
  };

  const isVisibleForm = isEdit ? !isFetching && !!permit?.id : true;

  useEffect(() => {
    if (editingAcccess === false && !!isOpen) {
      confirm({
        content: 'Достигнут лимит по созданию пропуска.',
        cancelButtonProps: {
          style: { display: 'none' },
        },
      });
    }
  }, [editingAcccess, isOpen]);

  return (
    <Modal
      visible={isOpen}
      width={800}
      onCancel={handleCancel}
      destroyOnClose
      title={!!id ? 'Редактировать пропуск' : 'Добавить пропуск'}
      closable
      footer={
        <FooterModal
          onClose={handleCancel}
          onOk={handleSubmit}
          isLoading={isLoadingCreatePermit || isLoadingChangePermit}
          disabled={
            !editingAcccess || isLoadingCreatePermit || isLoadingChangePermit
          }
        />
      }
    >
      <Spin spinning={isFetching || isLoadingCheck}>
        {isVisibleForm && (
          <Form>
            <BodyFormPermit
              form={form}
              permit={permit}
              isEdit={isEdit}
              editingAcccess={editingAcccess}
              companyId={companyId}
            />
          </Form>
        )}
      </Spin>
    </Modal>
  );
};

const ModalPermit = Form.create('permit-form')(ModalPermitNode);
export default ModalPermit;
